import React, { useEffect, useState } from "react";
import { Button, Layout, Space, Table, Tag, Typography, Alert, Row, Input, Col, Modal, Form, Card, Divider } from 'antd';
import { EyeOutlined, UsergroupAddOutlined, CaretLeftOutlined, CaretRightOutlined, LockOutlined, DeleteOutlined, CloseOutlined, WalletOutlined, EditOutlined } from '@ant-design/icons';
import { Link, useNavigate } from "react-router-dom";
import { inject, observer } from 'mobx-react'
import { cloneDeep } from "lodash";
import "./style.scss";
import Swal from "sweetalert2";

const { Content } = Layout;
const { Title, Text } = Typography;
const { Search } = Input;

const TeamLeaders = ({ userStore }) => {

  const navigate = useNavigate()
  const [form] = Form.useForm();

  const userType = "TEAM_LEADER";

  const [isEditTeamLeader, setIsEditTeamLeader] = useState(false);
  const [editableTeamLeader, setEditableTeamLeader] = useState();

  useEffect(() => {
    userStore.page = 1;
    userStore.hasMore = false;
    userStore.perPage = 10;
    userStore.fetchUsersTeamLeaders(userType);
  }, []);

  const handlePrevPage = () => {
    userStore.page = userStore.page - 1;
    userStore.fetchUsersTeamLeaders(userType);
  };

  const handleNextPage = () => {
    userStore.page = userStore.page + 1;
    userStore.fetchUsersTeamLeaders(userType);
  };

  const onConfirmStatus = (id, userType) => {
    Swal.fire({
      title: "Deactivate Team Leader",
      icon: "question",
      text: "Are you sure do you want to deactivate team leader?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: `Cancel`,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        // function
      } 
    })
  };

  const onConfirmDelete = (id) => {
    Swal.fire({
      title: "Delete District Coordinator",
      icon: "question",
      text: "Are you sure do you want to delete District Coordinator?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: `Cancel`,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        userStore.deleteTeamLeader(id).then(() => {
          userStore.fetchUsersTeamLeaders(userType); // Refresh the list
        });
      } 
    })
  };

  const onConfirmReset = (id) => {
    Swal.fire({
      title: "Reset Password",
      icon: "question",
      text: "Are you sure do you want to Reset Password?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: `Cancel`,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        userStore.resetPassword(id).then(() => {
          userStore.fetchUsersTeamLeaders(userType); // Refresh the list
        });
      } 
    })
  };

  const formatNumber = (formatnumber) => {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(formatnumber);
  };

  const columns = [
    {
      title: 'Name',
      key: 'FullName+UserID',
      dataIndex: 'FullName',
      responsive: ['lg', 'xl', 'md'],
      render: (FullName) => (
        <Text default>{FullName}</Text>
      )
    },
    {
      title: 'Contact #',
      key: 'ContactNumber+UserID',
      dataIndex: 'ContactNumber',
      responsive: ['lg', 'xl', 'md'],
      render: (ContactNumber) => (
        <Text default>{ContactNumber}</Text>
      )
    },
    {
      title: 'Available Amount',
      key: 'Amount+UserID',
      dataIndex: 'Amount',
      responsive: ['lg', 'xl', 'md'],
      render: (Amount, record) => (
        <Text default strong>₱ {formatNumber(parseInt(record.Amount) + parseInt(record.ItemAmount))}</Text>
      )
    },
    {
      title: 'Status',
      dataIndex: 'IsActive',
      key: 'IsActive+UserID',
      render: (IsActive) => (
        <Tag color={IsActive == 1 ? "green" : "red"}><Text type="primary" strong>{IsActive == 1 ? 'ACTIVE' : 'INACTIVE'}</Text></Tag>
      )
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      width: "350px",
      render: (text, record) => (
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <Space size={'small'}>
              <Link to={'/team-leaders/'+record.UserID}><Button icon={<EyeOutlined/>} type="primary" ghost>View</Button></Link>
              <Button icon={<EditOutlined />} type="primary" ghost onClick={() => {
                setEditableTeamLeader(record);
                form.setFieldsValue({
                  FullName: record.FullName,
                  ContactNumber: record.ContactNumber,
                  Address: record.Address,
                  Remarks: record.Remarks
                });
                setIsEditTeamLeader(true);
              }}>Edit</Button>
              <Button 
                onClick={() => onConfirmDelete(record.UserID)}
                loading={userStore.loading}
                danger
                icon={<DeleteOutlined />}
                disabled={record.Amount != 0 ? true : false}
              >Delete</Button>
            </Space>
          </Col>
          <Col span={24}>
            <Space size={'small'}>
              <Button 
                fullWidth
                onClick={() => onConfirmReset(record.UserID)}
                loading={userStore.loading}
                danger
                icon={<LockOutlined />}
              >Reset Password</Button>
            </Space>
          </Col>
        </Row>
      )
    },
  ];

  const handleUpdateTeamLeader = (values) => {

    userStore.updateTeamLeader(values, editableTeamLeader.UserID).then(() => {
      setIsEditTeamLeader(false);
      userStore.fetchUsersTeamLeaders(userType); // Refresh the list
    });
  };

  return (
    <div className="admin-list-team-leader">
      <Content>
        <div className="admin-content-team-leader">
          <Row justify={"space-between"} align={"middle"}>
            <Col>
              <Title level={4}>District Coordinator List</Title>
            </Col>
            {/* <Col>
              <Row gutter={10} align={"middle"}>
                <Col>
                  <Button 
                    type="primary" 
                    icon={<UsergroupAddOutlined /> }
                    onClick={() => navigate('add')}
                  >Add Team Leader</Button>
                </Col>
                <Col>
                  <Button 
                    type="primary" 
                    icon={<WalletOutlined /> }
                    onClick={() => navigate('top-up')}
                  >Top Up Team Leaders</Button>
                </Col>
              </Row>
            </Col> */}
          </Row>
          <Alert
            message="List of Team Leaders"
            description="List of your registered District Coordinators. If you think there's a problem with the list of users, please contact an administrator for assistance."
            type="info"
            showIcon
          />
          <div className="mobile-data">
            {(cloneDeep(userStore.teamLeaders) ?? []).map((teamLeader) => (
              <Card 
                className="card-data"
                actions={[
                  <Link to={'/team-leaders/'+teamLeader.UserID}><Button icon={<EyeOutlined />} type="primary" ghost style={{width: "95%"}}>View</Button></Link>,
                  <Link to={`/team-leaders/${teamLeader.UserID}/edit`}><Button icon={<EditOutlined />} type="primary" ghost style={{width: "95%"}}>Edit</Button></Link>
                ]}
              >
                <Row gutter={10} align={"middle"}>
                  <Col>
                    <Text className="name-text" strong>{teamLeader.FullName}</Text>
                  </Col>
                  <Col>
                    <Tag color={teamLeader.IsActive == 1 ? "green" : "red"}>{teamLeader.IsActive == 1 ? 'ACTIVE' : 'INACTIVE'}</Tag>
                  </Col>
                </Row>
                <Text type="secondary">{teamLeader.ContactNumber}</Text>
                <Row gutter={10}>
                  <Text keyboard>Available Amount: {teamLeader.Amount}</Text>
                </Row>
                <Divider/>
                <Row gutter={10} justify="center">
                  {/* <Col>
                    <Link to={`/team-leaders/${teamLeader.UserID}/edit`}><Button  icon={<EditOutlined />} type="primary" ghost /></Link>
                  </Col> */}
                  <Col>
                    <Button 
                      onClick={() => onConfirmDelete(teamLeader.UserID, teamLeader.userType)}
                      loading={userStore.loading}
                      danger
                      icon={<DeleteOutlined />}
                    />
                  </Col>
                  <Col>
                    <Button 
                      onClick={() => onConfirmStatus(teamLeader.userID, teamLeader.userType)}
                      loading={userStore.loading}
                      danger
                      icon={<CloseOutlined />}
                      fullWidth
                    />
                  </Col>
                  <Col>
                    <Button 
                      fullWidth
                      onClick={() => onConfirmReset(teamLeader.userID, teamLeader.userType)}
                      loading={userStore.loading}
                      danger
                      icon={<LockOutlined />}
                    />
                  </Col>
                </Row>
              </Card>
              ))
            }
          </div>
          <div className="web-data">
            <Table pagination={false} columns={columns} dataSource={cloneDeep(userStore.teamLeaders)} bordered/>
          </div>
          <ul className="pagination">
            <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={userStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
            <li className="pagination-item"><a>{userStore.page}</a></li>
            <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={userStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
          </ul>
        </div>
        {/* EDIT BASIC DATA FROM TEAM LEADERS MODAL */}
        <Modal 
          title="Edit District Coordinator" 
          open={isEditTeamLeader} 
          onCancel={() => setIsEditTeamLeader(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsEditTeamLeader(false)}>Cancel</Button>,
            <Button key="submit" type="primary" onClick={() => form.submit()}>Save Changes</Button>
          ]}
        >
          <Form
            name="editTeamLeaderData"
            layout="vertical"
            form={form} 
            onFinish={(values) => handleUpdateTeamLeader(values)}
          >
            <Form.Item label="Name" name="FullName" rules={[{ required: true, message: "Name is required" }]}>
              <Input placeholder="Enter Name" />
            </Form.Item>
            <Form.Item label="Address" name="Address" rules={[{ required: true, message: "Address is required" }]}>
              <Input placeholder="Enter Address" />
            </Form.Item>
            <Form.Item label="Contact Number" name="ContactNumber" rules={[{ required: true, message: "Contact number is required" }]}>
              <Input placeholder="Enter Contact Number" />
            </Form.Item>
            <Form.Item label="Remarks" name="Remarks" rules={[{ required: true, message: "Remarks is required" }]}>
              <Input.TextArea placeholder="Enter Remarks" />
            </Form.Item>
          </Form>
        </Modal>
      </Content>
    </div>

  );
};

export default inject('userStore')(observer(TeamLeaders));
